export default {
  HOMOLOG: 'HOMOLOG',
  DEVELOPMENT: 'DEVELOPMENT',
  PRODUCTION: 'PRODUCTION',
};

export const SYSTEM_VARIABLE = {
  ENV: process.env.VUE_APP_ENV,
  BASE_URL: process.env.VUE_APP_BASE_URL,
  BASE_URL_API: process.env.VUE_APP_BASE_URL_API,
  LANDINGPAGE_URL: process.env.VUE_APP_LANDINGPAGE_URL,
};
